"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderTypeStatusMapping = void 0;
exports.orderTypeStatusMapping = [
    {
        "Order Control Code": "AF",
        Description: "Order/service refill request approval"
    },
    {
        "Order Control Code": "CA",
        Description: "Cancel order/service request"
    },
    {
        "Order Control Code": "CH",
        Description: "Child order/service"
    },
    {
        "Order Control Code": "CN",
        Description: "Combined result"
    },
    {
        "Order Control Code": "CR",
        Description: "Canceled as requested"
    },
    {
        "Order Control Code": "DC",
        Description: "Discontinue order/service request"
    },
    {
        "Order Control Code": "DE",
        Description: "Data errors"
    },
    {
        "Order Control Code": "DF",
        Description: "Order/service refill request denied"
    },
    {
        "Order Control Code": "DR",
        Description: "Discontinued as requested"
    },
    {
        "Order Control Code": "FU",
        Description: "Order/service refilled, unsolicited"
    },
    {
        "Order Control Code": "HD",
        Description: "Hold order request"
    },
    {
        "Order Control Code": "HR",
        Description: "On hold as requested"
    },
    {
        "Order Control Code": "LI",
        Description: "Link order/service to patient care problem or goal"
    },
    {
        "Order Control Code": "NA",
        Description: "Number assigned"
    },
    {
        "Order Control Code": "NW",
        Description: "New order/service"
    },
    {
        "Order Control Code": "OC",
        Description: "Order/service canceled"
    },
    {
        "Order Control Code": "OD",
        Description: "Order/service discontinued"
    },
    {
        "Order Control Code": "OE",
        Description: "Order/service released"
    },
    {
        "Order Control Code": "OF",
        Description: "Order/service refilled as requested"
    },
    {
        "Order Control Code": "OH",
        Description: "Order/service held"
    },
    {
        "Order Control Code": "OK",
        Description: "Order/service accepted & OK"
    },
    {
        "Order Control Code": "OP",
        Description: "Notification of order for outside dispense"
    },
    {
        "Order Control Code": "OR",
        Description: "Released as requested"
    },
    {
        "Order Control Code": "PA",
        Description: "Parent order/service"
    },
    {
        "Order Control Code": "PY",
        Description: "Notification of replacement order for outside dispense"
    },
    {
        "Order Control Code": "RE",
        Description: "Observations/Performed Service to follow"
    },
    {
        "Order Control Code": "RF",
        Description: "Refill order/service request"
    },
    {
        "Order Control Code": "RL",
        Description: "Release previous hold"
    },
    {
        "Order Control Code": "RO",
        Description: "Replacement order"
    },
    {
        "Order Control Code": "RP",
        Description: "Order/service replace request"
    },
    {
        "Order Control Code": "RQ",
        Description: "Replaced as requested"
    },
    {
        "Order Control Code": "RR",
        Description: "Request received"
    },
    {
        "Order Control Code": "RU",
        Description: "Replaced unsolicited"
    },
    {
        "Order Control Code": "SC",
        Description: "Status changed"
    },
    {
        "Order Control Code": "SN",
        Description: "Send order/service number"
    },
    {
        "Order Control Code": "SR",
        Description: "Response to send order/service status request"
    },
    {
        "Order Control Code": "SS",
        Description: "Send order/service status request"
    },
    {
        "Order Control Code": "UA",
        Description: "Unable to accept order/service"
    },
    {
        "Order Control Code": "UC",
        Description: "Unable to cancel"
    },
    {
        "Order Control Code": "UD",
        Description: "Unable to discontinue"
    },
    {
        "Order Control Code": "UF",
        Description: "Unable to refill"
    },
    {
        "Order Control Code": "UH",
        Description: "Unable to put on hold"
    },
    {
        "Order Control Code": "UM",
        Description: "Unable to replace"
    },
    {
        "Order Control Code": "UN",
        Description: "Unlink order/service from patient care problem or goal"
    },
    {
        "Order Control Code": "UR",
        Description: "Unable to release"
    },
    {
        "Order Control Code": "UX",
        Description: "Unable to change"
    },
    {
        "Order Control Code": "XO",
        Description: "Change order/service request"
    },
    {
        "Order Control Code": "XR",
        Description: "Changed as requested"
    },
    {
        "Order Control Code": "XX",
        Description: "Order/service changed, unsol."
    }
];
//# sourceMappingURL=order-type-status.js.map